import Vue from 'vue'
import VueI18n from "vue-i18n";
import { TranslationsService } from "@/core/Services"

let i18nInstance = null
const I18N_OPTIONS_KEY = 'i18n-options'

// interpolateString("I'm {age} years old!", { age: 29 })
// interpolateString("The {a} says {n}, {n}, {n}!", { a: 'cow', n: 'moo' })
// interpolateString("The {0} says {1}, {1}, {1}!", ['cow', 'moo'])
function interpolateString(str, o) {
  return str.replace(/{([^{}]*)}/g,
    function (a, b) {
      const r = o[b]
      return typeof r === 'string' || typeof r === 'number' ? r : a
    }
  )
}

function getI18nOptions() {
  return JSON.parse(localStorage.getItem(I18N_OPTIONS_KEY))
}

function setI18nOptions(i18nOptions) {
  localStorage.setItem(I18N_OPTIONS_KEY, JSON.stringify(i18nOptions))
}

function setLanguages(languages) {
  localStorage.setItem('languages', JSON.stringify(languages))
}

function getLanguages() {
  return JSON.parse(localStorage.getItem('languages'))
}

function getLanguageName() {
  const languages = getLanguages()
  for (const language of languages) {
    if (language.culture_name === i18nInstance.locale) {
      return language.culture_display_name
    }
  }
}

function changeLocale(newLocale) {
  i18nInstance.locale = newLocale
  const i18nOptions = getI18nOptions()
  i18nOptions.locale = newLocale
  setI18nOptions(i18nOptions)
}

async function initI18n() {
  Vue.use(VueI18n)
  let locale = navigator.language
  let fallbackLocale = navigator.language
  let i18nOptions = getI18nOptions()
  if (i18nOptions) {
    locale = i18nOptions.locale
  }

  if (navigator.onLine) {
    const languagesResponse = await TranslationsService.getLanguages()
    const messages = {}
    setLanguages(languagesResponse.data)
    for (const language of languagesResponse.data) {
      const response = await TranslationsService.getTranslations(language.culture_name)
      if (language.suggested) {
        fallbackLocale = language.culture_name
      }
      messages[language.culture_name] = response.data
    }
    i18nOptions = { locale, fallbackLocale, messages }
    setI18nOptions(i18nOptions)
  }
  if (!i18nOptions) {
    throw 'No connection and no local storage translations available to load.'
  }
  i18nInstance = new VueI18n(i18nOptions)
  return i18nInstance
}

export default {
  initI18n,
  changeLocale,
  getLanguages,
  getLanguageName,
  interpolateString
}
